import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import ArticleWrap from '../../components/organisms/articleWrap';
import ArticleBody from '../../components/organisms/articleBody';
import ColumnDetailAside from '../../components/organisms/columnDetail/columnDetailAside';
import ArticleHeader from '../../components/molecules/articleHeader';
import ArticleSection from '../../components/molecules/articleSection';
import ArticleImage from '../../components/atoms/articleImage';
import TextBlock from '../../components/molecules/textBlock';
import Text from '../../components/atoms/text';
import Caption from '../../components/atoms/caption';
import ColumnRecommendItems from '../../components/organisms/columnDetail/columnRecommendItems';
import ColumnRecommendItemsSection from '../../components/organisms/columnDetail/columnRecommendItemsSection';
import Br from '../../components/atoms/br';
import { getProductItem } from '../../assets/js/lib/getProducts';

const Container = styled.div`
`;

const ColumnDetail = () => {
  return (
    <Container>
      <Helmet
        title="歯の「再石灰化」に注目！初期むし歯はホームケアで修復しよう | お口の健康コラム | モンダミン 公式サイト | アース製薬"
        meta={[
              { name: 'description', content: 'あっという間に進行してしまうむし歯。初期むし歯から進行しないように、日々のちょっとした時間で行うホームケアが大切です。今回はむし歯ができる仕組みや、おすすめのケア方法をご紹介します。' },
              { name: 'keywords', content: 'マウスウォッシュ,洗口液,液体ハミガキ,液体歯磨き,モンダミン,もんだみん,mondahmin,むし歯,初期むし歯,オーラルケア,アース製薬' }
        ]}
      >
        <body data-block-header="true" />
      </Helmet>
      <ArticleWrap>
        <ArticleBody>
          <ArticleHeader sub={<>歯の「再石灰化」に注目！</>} title={<>初期むし歯はホームケアで修復しよう</>} filename={'column/07/img-01.jpg'}>
            あっという間に進行してしまうむし歯。初期むし歯から進行しないように、日々のちょっとした時間で行うホームケアが大切です。
          </ArticleHeader>
          <ArticleSection heading={<>初期むし歯とは？ むし歯ができる仕組み</>}>
            <TextBlock>
              <Text>むし歯とは、口内の細菌が食べカスなどの糖質を分解して作り出した酸によって、歯が溶けてしまうことです。<br />「初期むし歯」は歯垢（プラーク）から出る酸によって、歯からミネラルが溶け出し、表面からわずかに内側の密度が低くなった状態で、歯に穴があく手前の段階です。歯の表面にツヤがなく、白濁や薄茶色に見えるといった特徴がありますが気づきにくく、痛みもありません。「軽度のむし歯」はエナメル質が溶けて穴があき、黒く見えますが痛みはほとんどありません。「冷たい飲食物がしみる」「食べ物がひっかかるようになった」など、私たちが異変に気づいて歯科を受診しようと思った時には、「中度のむし歯」になっており、さらに進行すると歯の大部分が溶けてしまい、激しい痛みを伴う「重度のむし歯」になってしまいます。</Text>
              <ArticleImage onlyPc filename={'column/07/img-02.jpg'}></ArticleImage>
              <ArticleImage onlySp filename={'column/07/sp/img-02.jpg'}></ArticleImage>
              <Text>ちなみに、「初期むし歯」はホームケアで元に戻すことができますが、「軽度のむし歯」になってしまうと歯科医院での治療が必要です。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>初期むし歯を元に戻すはたらき「再石灰化」とは？</>}>
            <TextBlock>
              <Text>私たちの口内では、歯を溶かす「脱灰」と、修復を行う「再石灰化」が繰り返されています。<br />脱灰とは、むし歯菌*が作り出した酸によって、歯の表面のエナメル質からカルシウムやリン酸が溶け出てしまうことです。再石灰化とは、脱灰によって溶け出したカルシウムやリン酸が唾液によって再び歯に取り込まれ、歯が元に戻ることです。脱灰と再石灰化が同じ程度で繰り返されている間は、健康な歯が保たれます。</Text>
              <Caption>＊むし歯の原因となる細菌には様々な種類がありますが、ここではまとめて「むし歯菌」と呼びます。</Caption>
              <ArticleImage onlyPc filename={'column/07/img-03.jpg'}></ArticleImage>
              <ArticleImage onlySp filename={'column/07/sp/img-03.jpg'}></ArticleImage>
              <Text>ところが、糖質を頻繁に摂取したり、オーラルケアを怠って歯垢が長時間付着しているなど、脱灰が促進されるような口内環境が続くと、再石灰化の修復スピードが追いつかず、初期むし歯へと進行してしまいます。ただし、初期むし歯の段階で脱灰よりも再石灰化が促進されると、歯が修復されて元に戻ります。<br />ちなみにフッ素には、歯面の強化や、再石灰化を促進する作用、歯垢にいるむし歯菌が作り出す酸の生成を抑制するといった働きがあり、歯科医院の予防に使用されたり、ハミガキ剤などのホームケア用品に配合されています。</Text>
              <Text>細菌が作り出す歯垢は、ネバネバしていて歯の表面にしっかりとくっついているため、水うがいくらいでは取り除くことができません。また、歯垢を作らないためには、口内の細菌のエサとなる食べカスなどを、食後の口内に残さないことが大切です。したがって、初期むし歯の段階で治すには、ブラッシングによる歯垢の除去、フッ素配合のハミガキ剤の使用に加え、洗口液などによるこまめなホームケアが大切です。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>初期むし歯対策は、こまめな口内ケアにあり</>}>
            <TextBlock>
              <Text>むし歯を進行させないためには、歯垢をしっかり落とすことはもちろん、エサとなる食べカスを口内に放置しないよう、食後の歯磨きなど、日頃からオーラルケアを行って口内環境を整えることがポイントです。</Text>
              <Text>もし、歯磨きをする時間がなくても、洗口液で口を20〜30秒すすぐことで汚れを洗い流し、口内全体を清潔にできます。また、歯磨き後に使えば磨き残し対策に。歯垢の付着を防ぐ洗口液もあるので、製品の説明書きをチェックしてみましょう。<br />ちなみに、ほんの1枚のクッキーやのど飴を食べるだけでも細菌のエサとなってしまいます。その度に歯磨きするのは面倒かもしれませんが、洗口液ですすぐ程度であれば、毎日の習慣として取り入れやすいのでおすすめです。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>「むし歯になりやすい場所」は特に清潔に</>}>
            <TextBlock>
              <Text>むし歯になりやすいのは、「歯と歯の間」「歯と歯ぐきとの境目」「詰め物・被せものの境目」など、凸凹のある部分でいずれも歯ブラシが届きにくいところです。さらに、大人になると加齢や歯周病が原因で歯ぐきが下がってしまった部分がむし歯になりやすいので注意が必要です。<br />細かい部分は歯ブラシでは磨きづらいため、タフトブラシやフロスを使ってお掃除しましょう。また、洗口液は歯ブラシが届きにくいところにも行き渡り、口内全体を清潔にします。時間のある時は歯磨きに洗口液などのアイテムをプラスして、時間のない時は洗口液ですすぐなど、なるべく早く口内を清潔にしましょう。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>初期むし歯で進行ストップ！ プラスアルファのホームケア</>}>
            <TextBlock>
              <ArticleImage filename={'column/07/img-04.jpg'}></ArticleImage>
              <Text>歯科医院での検診は、初期むし歯など自分では気づかない変化を早めに見つけて処置してくれるので、定期的に受診するのがおすすめです。しかし、むし歯の進行を抑えるには、やはり毎日のホームケアが大切。むし歯菌が喜ぶ状態をできるだけ少なくすれば、むし歯の進行だけでなく、口臭予防にも効果的です。ぜひ、フロスや洗口液などを上手に使って、口内環境を改善していきましょう。</Text>
            </TextBlock>
          </ArticleSection>
        </ArticleBody>
      </ArticleWrap>
      <ColumnRecommendItemsSection>
        <ColumnRecommendItems title={"よごれの除去と付着予防に"} items={getProductItem(['モンダミン ペパーミント', 'モンダミン センシティブ', 'モンダミン ストロングミント',])}></ColumnRecommendItems>
        <ColumnRecommendItems title={<>むし歯など、<Br onlySp></Br>様々なお口のトラブル予防に</>} column={[3,2]} items={getProductItem(['モンダミン プレミアムケア', 'モンダミン プレミアムケア センシティブ', 'モンダミン プレミアムケア センシティブ プレミアムシトラスミント', 'モンダミン プレミアムケア ストロングミント', '自動で出てくるモンダミン プレミアムケアセット'])}></ColumnRecommendItems>
        <ColumnRecommendItems title={<>フッ素で再石灰化を促進、<Br onlySp></Br>むし歯予防に</>} items={getProductItem(['モンダミンKid\'s フッ素仕上げジェルセット ぶどう味', 'モンダミンJr. フッ素仕上げジェル グレープミックス味'])}></ColumnRecommendItems>
      </ColumnRecommendItemsSection>
      <ColumnDetailAside></ColumnDetailAside>
    </Container>
  );
};
export default ColumnDetail;
